import { IoIosArrowForward } from "react-icons/io";
import styled, { css } from "styled-components";

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  width: 100%;
  margin: 0 0 2rem;

  @media (max-width: 530px) {
    margin: 0 0 1rem;
  }
`;

export const ArrowRightIcon = styled(IoIosArrowForward)`
  font-size: 1.5rem;
  color: ${(props) => `${props.theme?.checkoutStepsOffers?.textColor}6f`};

  @media (max-width: 530px) {
    font-size: 1.25rem;
  }

  @media (max-width: 375px) {
    font-size: 1rem;
  }
`;

export const StepContainer = styled.div<IStep>`
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    !props.active &&
    css`
      opacity: 0.5;
    `}

  cursor: ${(props) => (!!props.onClick ? "pointer" : "default")};
`;

interface IStep {
  active: boolean;
}

export const Step = styled.strong`
  margin: 0 0 0 0.5rem;

  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.688rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.textColor};

  @media (max-width: 530px) {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  @media (max-width: 375px) {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
`;

export const Number = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 2.75rem;
  height: 2.75rem;

  font-family: Inter;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.688rem;

  border-radius: 100%;
  color: ${({ theme }) => theme.checkoutStepsOffers?.checkoutTextPrimary};
  background: ${(props) =>
    props.theme?.checkoutStepsOffers?.checkoutPrimaryColor ||
    props.theme?.colors?.primary};

  @media (max-width: 530px) {
    font-size: 1rem;
    line-height: 1.5rem;

    width: 2rem;
    height: 2rem;
  }

  @media (max-width: 375px) {
    font-size: 0.875rem;
    line-height: 1.25rem;

    width: 1.75rem;
    height: 1.75rem;
  }
`;
